import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { Store } from '@ngrx/store';
import { LOGIN, MAIN } from '@core/constants/RoutingsPath';
import { Router } from '@angular/router';
import { RedirectAfterLoginService } from '@core/services/redirect-after-login.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    public messageService: MessageService,
    private router: Router,
    private store: Store,
    private redirectAfterLoginService: RedirectAfterLoginService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe((source) => this.handleErrors(source, request));
  }

  private handleErrors(source: Observable<HttpEvent<any>>, request: HttpRequest<any>) {
    return source.pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        console.log('ErrorInterceptor->:', errorResponse);
        const errorMsg = errorResponse.error?.message;
        const summary = errorResponse.error?.summary || 'Error';
        const urlPath = request.url;
        !!errorMsg &&
          this.messageService.add({
            severity: 'error',
            summary,
            detail: errorMsg,
            sticky: true
          });

        if (errorResponse.status === HttpStatusCode.Unauthorized) {
          this.handle401(urlPath, errorResponse);
        }

        return throwError(() => errorResponse);
      })
    );
  }

  private handle401(urlPath: string, errorResponse: HttpErrorResponse) {
    // An expired session must not cost the user the page they were on.
    this.redirectAfterLoginService.remember(this.router.url);
    this.router.navigateByUrl(this.router.createUrlTree([MAIN, LOGIN]));
    location.reload();
  }
}
